import React from 'react';
import './Button.css'
const Button = ({children}) => {
    return (
        <div>
            <button className="button bg-button">{children}</button>
        </div>
    );
};

export default Button;